// removed by extract-text-webpack-plugin
module.exports = {"container":"_1OLInBo","widgetButton":"wN7TsRy","noOfBagItems":"_1EbtfBz","bounce-minibag":"_26mzG9J"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Widgets/Widgets.css
// module id = ./template/components/Widgets/Widgets.css
// module chunks = client.sitechrome